// Which OpenWrench browser tab the user was last in, shared across tabs through localStorage, so
// something every tab hears at once (a socket message) can be shown in just one of them.
const LAST_ACTIVE_TAB_KEY = 'ow-last-active-tab';
const TAB_ID = `${Date.now()}-${Math.random().toString(36).slice(2)}`;

const isVisible = (): boolean => document.visibilityState === 'visible';

const claimActiveTab = () => {
	try {
		localStorage.setItem(LAST_ACTIVE_TAB_KEY, TAB_ID);
	} catch (error) {
		// Storage blocked: isLastActiveTab falls back to visibility.
	}
};

// Records this tab as the active one whenever it is shown or focused; returns the cleanup.
export const trackActiveTab = (): (() => void) => {
	const handleVisibilityChange = () => {
		if (isVisible()) claimActiveTab();
	};
	if (isVisible()) claimActiveTab();
	document.addEventListener('visibilitychange', handleVisibilityChange);
	window.addEventListener('focus', claimActiveTab);
	return () => {
		document.removeEventListener('visibilitychange', handleVisibilityChange);
		window.removeEventListener('focus', claimActiveTab);
	};
};

// True in the tab the user was last in, even if they've since switched to another app.
export const isLastActiveTab = (): boolean => {
	try {
		const activeTabId = localStorage.getItem(LAST_ACTIVE_TAB_KEY);
		return activeTabId ? activeTabId === TAB_ID : isVisible();
	} catch (error) {
		return isVisible();
	}
};
